import {createImgIn} from '../ui_utils/DomUtils'
import {ViewPopup} from './ViewPopup'
import {LobbyImage} from '@colonist/types'
import {UIUtilsEjsVariables} from '../UIUtilsEjsVariables'
import {StorageWrapper} from '../StorageWrapper'
import {ClientPlatformRedirection} from '../ClientPlatformRedirection'

export class UISwitchToPortraitPopup extends ViewPopup {
    constructor(xAction: () => void) {
        super({key: 'strings:popups.switchToPortrait.title'},
            {key: 'strings:popups.switchToPortrait.description', options: {date: UIUtilsEjsVariables.portraitModeEnforcementDate}},
            () => {
                StorageWrapper.setPortraitModeEnforcementAccepted(true)
                ClientPlatformRedirection.handleRedirectNewAccountsToMobileWeb()
            },
            xAction,
            false, {
                checkButtonCustomContent: {key: 'strings:popups.switchToPortrait.okButton'},
                xButtonCustomContent: {key: 'strings:popups.switchToPortrait.cancelButton'},
            })
        this.xButton.style.backgroundColor = 'rgba(0, 0, 0, 0.2)'
        const img = createImgIn(this.body, LobbyImage.SwitchToPortrait, '')
        this.body.prepend(img)
    }
}
